import { createMuiTheme } from "@material-ui/core/styles/index";
import createPalette from "@material-ui/core/styles/createPalette";
import createTypography from "@material-ui/core/styles/createTypography";
import createSpacing from "@material-ui/core/styles/createSpacing";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";
import createShadows from "@material-ui/core/styles/shadows";

const palette = createPalette({
  primary: {
    light: "#FF9C3A",
    main: "#FF8200",
    dark: "#FC6D00",
    contrastText: "#fff"
  },
  secondary: {
    light: "#0069BA",
    main: "#0057B8",
    dark: "#0047C1",
    contrastText: "#fff"
  },
  grey: {
    eccoGrey: "#363636",
    eccoLigth: "#797979"
  },
  common: {
    danger: '#e4002b',
    warning: '#ff8811',
    success: '#007a6e'
  }
});


const typography = createTypography(palette, {
  fontFamily: [
    '"Roboto"',
    '"Open Sans"',
    "Helvetica",
    "Arial",
    "sans-serif"
  ].join(","),
  h2Desktop : {
    fontFamily: "Roboto",
    fontSize: '1.875rem',
    color: "#FF8200",
  },
  h2Mobile: {
    fontFamily: "Roboto",
    fontSize: '1.5625rem',
    color: "#FF8200",
  } 
});

const spacingValues = {
  "3": 3,
  "4": 4,
  "5": 5,
  "7": 7
};

const spacing = createSpacing(args => {
  let output;

  if (Array.isArray(args)) {
    const [factor, input] = Array.from(args);
    output = spacingValues[factor] * input;
  } else {
    const defaultMuiSpacing = spacingValues["4"] * 2;
    output = args * defaultMuiSpacing;
  }

  return output;
});

 const breakpoints = createBreakpoints({
  values: {
    xs: 480,
    sm: 768,
    md: 992,
    lg: 1200
  }
}); 

const shadows = createShadows;
const shadowEcco = "3px 3px 10px rgba(0,0,0,0.06)";
shadows.splice(1, 0, shadowEcco);

const { pxToRem } = typography;

const theme = createMuiTheme({
  palette,
  typography,
  spacing,
  breakpoints,
  shadows,
  shape: {
    borderRadius: 15
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "@font-face": ['"Roboto"'],
        'input[type="number"]': {
          "-webkit-appearance": "textfield",

          "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            margin: 0
          }
        },
        body: {
          backgroundColor: '#f6f6f6'
        }
      }
    },
    MuiButton: {
      root: {
        borderRadius: 24,
        margin: spacing(["4", 1]),
        textTransform: "none",
        color: "#7D7D7D",
        fontSize: pxToRem(12),
        padding: spacing(["7", 1], ["4", 4])
      },
      sizeSmall: {
        fontSize: pxToRem(11),
        padding: spacing(["3", 2], ["4", 2])
      },
      sizeLarge: {
        fontSize: pxToRem(14),
        padding: spacing(["3", 3], ["4", 6]),
      },
      contained: {
        boxShadow: "none",

        "&:hover": {
          boxShadow: "none"
        }
      },
      outlined: {
        padding: spacing(["3", 2], ["4", 4]),

        "&$sizeSmall": {
          padding: spacing(["5", 1], ["4", 2])
        },

        "&$sizeLarge": {
          padding: spacing(["4", 2], ["4", 6])
        }
      }
    },
    MuiDivider: {
      root: {
        height: 1.5
      }
    },
    MuiFormLabel: {
      root: {
        fontSize: pxToRem(14),
        [breakpoints.down(375)]: {
          fontSize: pxToRem(12),
        }
      }
    },
    MuiFormControlLabel: {
      label: {
        fontSize: pxToRem(14),
        [breakpoints.down(375)]: {
          fontSize: pxToRem(12),
        }
      }
    },
    MuiInput: {
      underline: {
        "&:after": {
          borderBottom: `2px solid ${palette.primary.main}`
        }
      }, 
    },

    MuiFilledInput: {
      root: {
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
      },
      underline: {
        "&:after": {
          borderBottom: `2px solid ${palette.primary.main}`
        }
      }
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 4,
      }
    },
    MuiInputBase: {
      root: {
         fontSize: pxToRem(14), 
       /*  [breakpoints.down(375)]: {
          fontSize: pxToRem(12),
        }  */
      },
      /* input: {
        height: "auto"
      } */
    },
    MuiFormHelperText: {
      root: {
        /* [breakpoints.down(375)]: {
          fontSize: pxToRem(11),
        } */
      }
    }
  }
});

export default theme;